<template>
  <button
    class="community-cta"
    data-test-id="stories-community-cta"
    @click="handleClick"
  >
    <picture>
      <source
        type="image/webp"
        srcset="/common/nexus/stories-cta.webp"
      >
      <img
        src="/common/nexus/stories-cta.png"
        alt=""
        class="community-cta__img"
        data-test-id="stories-cta-image"
        loading="lazy"
      >
    </picture>
    <span class="community-cta__content">
      <span class="community-cta__text">
        Have a story to share?
      </span>
      <span class="community-cta__direction">
        Share your story
        <icon-component
          name="caret"
          title="caret icon"
          class="community-cta__icon icon--smallest"
        />
      </span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'StoriesCta',
  methods: {
    handleClick() {
      this.$router.push({ name: 'createStory' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_community-cta';
</style>

<docs>
</docs>
